<template>
  <Wrapper :type="type" @delete="$emit('delete')">
    <div
      slot="preview"
      :class="fontSize"
      v-if="type === 'HTML'"
      v-html="data.value"
    ></div>
    <div slot="preview" :class="fontSize" v-else v-text="data.value"></div>
    <component
      :is="componentType"
      slot="edition"
      :value="data.value"
      label="Value"
      box
      @input="setValue"
    ></component>
  </Wrapper>
</template>

<script>
import Wrapper from "../../components/widgets/Wrapper";
import VTextField from "vuetify/lib/components/VTextField";
import VTextarea from "vuetify/lib/components/VTextarea";

export default {
  name: "WidgetText",
  components: {
    Wrapper,
    VTextField,
    VTextarea
  },
  model: {
    prop: "data"
  },
  props: {
    type: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    fontSize() {
      return {
        "display-4": ["H1", "DISPLAY1"].includes(this.type),
        "display-3": ["H2", "DISPLAY2"].includes(this.type),
        "display-2": ["H3", "DISPLAY3"].includes(this.type),
        "display-1": ["H4", "DISPLAY4"].includes(this.type),
        headline: this.type === "H5",
        title: ["H6", "TITLE"].includes(this.type),
        subheading: ["SUBTITLE", "HEADLINE", "SUBHEAD"].includes(this.type),
        "body-1": ["BODY1", "P"].includes(this.type),
        "body-2": this.type === "BODY2",
        blockquote: this.type === "Q",
        caption: this.type === "CAPTION",
        "overline caption": this.type === "OVERLINE"
      };
    },
    componentType() {
      return this.type === "P" ? "VTextarea" : "VTextField";
    }
  },
  methods: {
    setValue(value) {
      this.$emit("input", {
        value
      });
    }
  }
};
</script>

<style lang="sass">
.overline
  text-decoration:
    line: underline
    style: dashed
</style>
